// src/components/home/home.jsx
// import style from './Home.module.css';
// import Contacts from '../info/Contacts';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Home() {
    // return (
    //     <div className={style.content}>
    //         <h3>Вас вітає Краща доставка суші в Києві - EMRYBU!</h3>
    //         <Contacts />
    //     </div>
    // );
    const navigate = useNavigate();
    useEffect(() => {
        navigate('/menu', { replace: true });
    }, [navigate]);

    return null;
}

export default Home;
